import { useLocation } from 'react-router-dom';
import { Divider } from '@mui/material';

// hooks
import useActiveLink from '../../../hooks/useActiveLink';
//
import { NavListProps } from '../types';

import NavItem from './NavItem';

// ----------------------------------------------------------------------

type NavListRootProps = {
  data: NavListProps;
  depth: number;
  hasChild: boolean;
};

export default function NavList({ data, depth, hasChild }: NavListRootProps) {
  const { pathname, search, hash } = useLocation();
  const { isExternalLink } = useActiveLink(data.path, hasChild ? true : false);
  const fullPath = `${pathname}${search}${hash}`;
  const hasActivePaths = data.activePaths
    ? data.activePaths.some((path) => path === fullPath)
    : false;

  return (
    <>
      {data.children &&
        data.children.map((child: NavListProps, index: number) => {
          const isLastItem = index === data.children.length - 1;
          return (
            <div key={child.title + child.path}>
              <NavItem
                item={child}
                depth={depth}
                active={hasActivePaths}
                isExternalLink={isExternalLink}
              />
              {isLastItem && <Divider sx={{ my: 1 }} />}
            </div>
          );
        })}
    </>
  );
}

// ----------------------------------------------------------------------

type NavListSubProps = {
  data: NavListProps[];
  depth: number;
};

function NavSubList({ data, depth }: NavListSubProps) {
  return (
    <>
      {data.map((list) => (
        <NavList
          key={list.title + list.path}
          data={list}
          depth={depth + 1}
          hasChild={!!list.children}
        />
      ))}
    </>
  );
}
